import httpInstance from "../httpInstance";

export const putReservations = async (jwtToken: string, reservationId: number, status?: string, comments?: string, start?: string, finish?: string, description?: string, resource?: number) => {
    let res: any;
    const endpoint = `reservation/${reservationId}/`;

    const data = {
        status: status,
        comments: comments,
        start: start,
        finish: finish,
        description: description,
        resource: resource,
    };

    const config = {
        headers: {
            Authorization: `${jwtToken}`,
        }
    };

    await httpInstance.put(endpoint, data, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}

export const putAdminReservations = async (jwtToken: string, reservationId: number, status?: string, comments?: string, start?: string, finish?: string, description?: string, resource?: number) => {
    let res: any;
    const endpoint = `adminReservation/${reservationId}/`;

    const data = {
        status: status,
        comments: comments,
        start: start,
        finish: finish,
        description: description,
        resource: resource,
    };

    const config = {
        headers: {
            Authorization: `${jwtToken}`,
        }
    };

    await httpInstance.put(endpoint, data, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });
    return res;
}